<div class="informacoes-chat row">
    <div class="col-12">
        <p class="p-0 m-0 equipe-name">{{equipe.name}}</p>
    </div>
    <div class="col-12">
        <p class="p-0 m-0 participantes">{{getParticipantes()}}</p>
    </div>
</div>
<div class="h-80 conversa flex-fill d-flex justify-content-center bg-light" id="conversa-area">
    <div class="h1 text-center my-auto p-5" *ngIf="chatMensagens.length == 0">
        <p>Inicie uma nova conversa</p>
    </div>

    <div #scrollContainer class="mensagens justify-content-end pt-2 pb-1 shadow-inner" *ngIf="chatMensagens.length > 0">
        <div class="mensagem d-flex flex-column mt-1 mx-3" [ngClass]="verificaLado(chatMensagem)"
            *ngFor="let chatMensagem of chatMensagens" id="mensagens-area">
            <div class="separador-mensagem d-flex col-12 my-5" *ngIf="adicionarData(chatMensagem)">
                <span class="data-separador font-weight-normal p-2">{{ chatMensagem.dataHoraEnvio | date:
                    'dd/MM/yyyy'}}</span>
            </div>
            <div class="mt-2">
                <div class="row" [ngClass]="{'inverter-balao' : isRemetente(chatMensagem)}">
                    <div class="col-auto">
                        <div class="user-foto-container">
                            <img src="../../../../assets/img/user.png" alt="Foto do usuário">
                        </div>
                    </div>
                    <div class="texto d-flex flex-column col-auto align-items-end justify-content-end py-2 px-4 text-white"
                        [ngClass]="[chatMensagem.url != null ? 'hasImage' : '', verificaCor(chatMensagem)]">
                        <div class="row">
                            <span class="mensagem-texto p-2">{{ chatMensagem.mensagem }}</span>
                        </div>
                        <div class="row w-100" *ngIf="chatMensagem.url != null">
                            <div class="square-image w-100">
                                <div class="inner-div" (click)="abrirFotoGrande(fotoGrandeTemplate, chatMensagem)">
                                    <img [src]="chatMensagem.url" class="img-fluid" alt="Imagem 1"
                                        *ngIf="isImageByExtension(chatMensagem.extensaoArquivo); else fileIcon" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row d-flex justify-content-end small mt-1"
                    [ngClass]="{'inverter-balao' : isRemetente(chatMensagem)}">
                    <span class="mr-2 font-primary-gray-700">{{chatMensagem.nomeRemetente}}</span>
                    <span class="mensagem-data mr-2">{{ chatMensagem.dataHoraEnvio | date: 'HH:mm'}}</span>
                </div>
            </div>

            <ng-template #fileIcon>
                <div class="w-100 h-100vh d-flex justify-content-center align-items-center">
                    <i class="fas fa-file fa-3x text-white"></i>
                </div>
            </ng-template>

            <ng-template #fotoGrandeTemplate>
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <img [src]="modalRef?.content" class="img-fluid" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-cancelar" (click)="modalRef.hide()">
                        Fechar
                    </button>
                    <button type="button" class="btn primary-white-button" (click)="baixarImagem(chatMensagem)">
                        Download
                    </button>
                </div>
            </ng-template>
        </div>
    </div>
</div>
<div class="envio-message" *ngIf="equipeId !== undefined">
    <div class="botoes" [ngClass]="exibirInputTexto ? 'botoes-texto' : 'botoes-arquivo'">
        <!-- <button title="Emoji" type="button" class="btn px-1 mr-1">
            <img src="../../../../assets/img/chat/emoji.svg" alt="Icone de emoji">
        </button> -->
        <button title="Anexar Arquivos" type="button" class="btn px-1 mr-1" (click)="fileInput.click()">
            <img src="../../../../assets/img/chat/anexo.svg" alt="Icone de clipe de papel">
        </button>
        <button title="Remover Arquivos" type="button" class="btn btn-remover-anexos px-1 mr-1" (click)="removeFiles()"
            *ngIf="!exibirInputTexto && selectedFiles.length > 0">
            <img src="../../../../assets/img/icons/dark-trash.svg" alt="Icone de lixeira">
        </button>
    </div>
    <div class="ml-2 mb-2" [ngClass]="exibirInputTexto ? 'campos-texto' : 'campos-arquivo'">
        <div class="campo-arquivo scroll-lista" *ngIf="!exibirInputTexto">
            <ul class="arquivo list-group mb-1">
                <li class="list-group-item d-flex justify-content-start align-items-center"
                    *ngFor="let file of selectedFiles; let i = index">
                    <img [src]="objectUrls[i]" *ngIf="isImage(file); else fileIcon" class="img-thumbnail" />
                    <span class="file-name"> {{ file.name }}</span>
                    <ng-template #fileIcon>
                        <i class="fileArquivo fas fa-file text-primary"></i>
                    </ng-template>
                </li>
            </ul>
        </div>
        <div class="campo-texto">
            <input type="text" class="inp-mensagem" placeholder="Digite uma mensagem..." name="mensagem"
                (keyup.enter)="enviarMensagem(!exibirInputTexto)" id="mensagem" [(ngModel)]="mensagem"
                #mensagemModel="ngModel" #mensagemEl />
            <abp-validation-summary [control]="mensagemModel" [controlEl]="mensagemEl"></abp-validation-summary>
        </div>

    </div>
    <div class="botoes ml-2 mb-3" [ngClass]="exibirInputTexto ? 'botoes-texto' : 'botoes-arquivo'">
        <button title="Enviar" type="button" class="btn primary-white-button" [disabled]="isSent"
            (click)="enviarMensagem(!exibirInputTexto)">
            <span class="px-1">
                Enviar
            </span>
            <img src="../../../../assets/img/chat/enviar.svg" alt="Icone de avião de papel">
        </button>
    </div>

    <input type="file" #fileInput style="display: none"
        accept="image/jpeg, image/png, image/gif, video/mp, video/avi, video/mov, application/pdf"
        (change)="onFilesSelected($event.target.files)" multiple autocomplete="off" />
</div>
